<template>
  <div>
    <div class="head-box">
      <h4>支付记录</h4>
      <div class="c-flex">
        <el-input
          style="width: 330px"
          placeholder="请输入委托方/合同编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-dropdown class="c-m-l-10" @command="handleMarkTag">
          <el-button type="primary">标记</el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item, tagIndex) in options['payTag']">
              <el-dropdown-item :key="tagIndex" :command="item.value">
                {{ item.label }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-button
          v-if="osg.has('PaymentRecords,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-regex:contractCode|string#or': searchValue,
              'fpi-ne:state|integer#and': '-1',
              beanName: 'paymentItem',
              title: '支付记录'
            })
          "
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          @selection-change="selectionChange"
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
        >
          <el-table-column type="selection" fixed width="55"></el-table-column>
          <el-table-column
            prop="contractCode"
            label="合同编号"
            width="200px"
            fixed
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="name" label="委托方" width="80px"></el-table-column>
          <el-table-column
            prop="exts.payTag"
            label="标记"
            width="50px"
            show-overflow-tooltip
            :formatter="formatterPayTag"
          ></el-table-column>
          <el-table-column
            prop="exts.payTagTime"
            label="标记时间"
            width="96px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="allPrice" label="增减项后合同金额" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.allPrice < 0" style="color: red">
                -{{ osg.amountFilter(scope.row.allPrice) }}
              </span>
              <span v-else>
                {{ osg.amountFilter(scope.row.allPrice) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" label="本次支付金额" width="100px">
            <template slot-scope="scope">
              <span :style="`${scope.row.payPrice < 0 ? 'color:red' : 'color:#000'}`">
                {{ osg.amountFilter(scope.row.payPrice) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="unpayPrice" label="未支付金额" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ osg.amountFilter(scope.row.unpayPrice) }}
            </template>
          </el-table-column>
          <el-table-column prop="refundFee" label="退款金额" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.refundFee" style="color: red">
                {{ osg.amountFilter(scope.row.refundFee) }}
              </span>
              <span v-else>
                {{ osg.amountFilter(scope.row.refundFee || 0) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="exts.refundFeeDetail"
            label="退款金额明细"
            width="100px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.refundFee" style="color: red">
                {{ scope.row.exts.refundFeeDetail ? scope.row.exts.refundFeeDetail : '' }}
              </span>
              <span v-else>
                {{ scope.row.exts.refundFeeDetail ? scope.row.exts.refundFeeDetail : '' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="refundNo"
            label="退款编号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.mchRefundNo"
            label="退款商户编号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.refundTime"
            label="退款时间"
            width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="refundType" label="退款方式" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ osg.codelabel('refundType', scope.row.refundType) }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="executor"
            label="付款人"
            width="70px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="payType"
            label="支付方式"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterPayType"
          ></el-table-column>
          <el-table-column
            prop="tradeIn"
            label="支付类型"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterTradeIn"
          ></el-table-column>
          <el-table-column
            prop="exts.mchPayType"
            label="商户支付类型"
            width="100px"
            show-overflow-tooltip
            :formatter="formatterMchPayType"
          ></el-table-column>
          <el-table-column
            prop="orderType"
            label="款项类型"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterOrderType"
          ></el-table-column>
          <el-table-column
            prop="exts.refundType2"
            label="退款类型"
            width="150px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.codelabel('refundType2', scope.row.exts['refundType2']) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="payTime"
            label="付款时间"
            width="140px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            label="服务商名称"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="tradeNo"
            label="交易编号"
            width="250px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.mchTradeNo"
            label="商户编号"
            width="210px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.comments"
            label="审核批语"
            width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="payState"
            label="收款状态"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterPayState"
          >
            <template slot-scope="scope">
              {{ '已收款' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="exts.rmContract"
            label="是否红冲"
            width="70px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.exts && scope.row.exts.rmContract ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="auditstate2Time"
            label="审核时间"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.payCarryOverMoney"
            label="结转金额"
            min-width="110px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.amountFilter(scope.row.exts.payCarryOverMoney) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="exts.payCarryOverTime"
            label="结转时间"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="_id"
            label="支付记录id"
            min-width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="type"
            label="类型"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPaymentRecordType"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="payState"
            label="收款状态"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPayState"
          ></el-table-column>
          <el-table-column
            prop="paidAmount"
            label="已收款金额"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="difference"
            :formatter="formatDifference"
            label="款项支付差额"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="price"
            label="本次审核金额(元)"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="totalAmount"
            label="总金额(元)"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createUserName"
            label="流水操作人"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orderType"
            label="款项类型"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterOrderType"
          ></el-table-column>
          <el-table-column
            prop="payTime"
            label="申请时间"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="comments"
            label="审批批语"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column> -->

          <!-- <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              show-overflow-tooltip
              :label="extFiel.nameDisp"
              :key="index"
              v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
            >
              <template slot-scope="scope">
                {{ formatterCodelabel(scope.row.exts[extFiel.name], extFiel.valueOption) }}
              </template>
            </el-table-column>
          </template> -->

          <!-- 分账记录 -->

          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="getLog(scope.row.payId)">
                    查看记录
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="settle(scope.row._id)">
                    手动生成结算明细
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 分账日志接口 -->
    <el-dialog
      class="divisionRecord"
      title="分账明细记录"
      :visible.sync="billingRecordShow"
      width="80%"
    >
      <el-table
        :data="billingRecordList"
        border
        default-expand-all
        :header-cell-style="{ 'background-color': '#F5F7FA' }"
      >
        <el-table-column label="分账方式" prop="payType" width="100px" align="center">
          <template slot-scope="slotPayType">
            {{ formatterPayType(null, null, slotPayType.row.payType) }}
          </template>
        </el-table-column>
        <el-table-column label="分账接收方名称" prop="resultReceivers" align="center">
          <template slot-scope="scope">
            <div
              class="card-table-cell"
              v-for="(item, index) in scope.row.resultReceivers"
              :key="index"
              :style="{
                borderBottom:
                  index + 1 === scope.row.resultReceivers.length ? 'none' : '1px solid #ebeef5'
              }"
            >
              {{ item.description }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分账金额(元)" prop="resultReceivers" align="center">
          <template slot-scope="scope">
            <div
              class="card-table-cell"
              v-for="(item, index) in scope.row.resultReceivers"
              :key="index"
              :style="{
                borderBottom:
                  index + 1 === scope.row.resultReceivers.length ? 'none' : '1px solid #ebeef5'
              }"
            >
              {{
                scope.row.payType === 1
                  ? (parseInt((item.amount / 100) * 100) / 100).toFixed(2)
                  : item.amount
              }}
              <!-- {{ scope.row.payType === 1 ? item.amount / 100 : item.amount }} -->
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="分账发起时间"
          prop="createTime"
          width="150px"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import common from '../../common/common';

export default {
  activated() {
    window.$this = this;
  },
  name: 'paymentItem',
  data() {
    return {
      name: 'paymentItem',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        // //工单
        // codecfg_priority: { codeId: 'PRIORITY' },
        // codecfg_stage: { codeId: 'STAGE' },
        // codecfg_status: { codeId: 'STATUS' },
        // //合同
        // codecfg_productType: { codeId: 'productType' },
        // codecfg_unit: { codeId: 'UNIT' },
        // codecfg_payState: { codeId: 'PAYSTATE' }
        codecfg_auditstate: { codeId: 'auditstate' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_mchPayType: { codeId: 'mchPayType' },
        codecfg_PaymentRecordType: { codeId: 'PaymentRecordType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' },
        codecfg_payTag: { codeId: 'payTag' }, //支付标记
        codecfg_refundType: { codeId: 'refundType' }, //支付退款审核类型
        codecfg_refundType2: { codeId: 'refundType2' } //支付退款退款类型
      },
      dynamic: {},
      params: {},
      contactList: [], //客户列表
      SAlist: [], //工单列表
      orderList: [], //订单列表
      selectedList: [], //被选中的支付记录
      type: null,
      billingRecordShow: false, //分账记录弹窗的显示
      billingRecordList: [] //分账记录的数据
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'serviceAppointment',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.options = this.options || [];
        //扩展字段选项关联字典表的查询出选项数据
        for (var item of res.data) {
          //解析frontEndConfig字段配置
          if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          }
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.extFields = res.data;
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData(dataObj => {
            this.options['payTag'].unshift({ label: '取消标记', value: '' });
            // let p1 = this.getContacts(dataObj.contactIds);
            // let p2 = this.getSA(dataObj.SAids);
            // Promise.all([p1, p2])
            //   .then(() => {
            //     //给工单列表动态的加列，因为后端支付表里没有工单、客户的一些字段
            //     for (var fpiItem of this.fpi.data) {
            //       for (let contactItem of this.contactList) {
            //         if (fpiItem.userId == contactItem._id) {
            //           fpiItem.phone = contactItem.phone;
            //         }
            //       }
            //       for (let SAitem of this.SAlist) {
            //         if (fpiItem.serviceAppointmentId == SAitem._id) {
            //           fpiItem.totalAmount = SAitem.totalAmount;
            //           fpiItem.paidAmount = SAitem.paidAmount;
            //         }
            //       }
            //     }
            //     //存储动态扩展的字段
            //     this.dynamic.phone = 'phone';
            //     this.dynamic.totalAmount = 'totalAmount';
            //     this.dynamic.paidAmount = 'paidAmount';
            //     this.fpi.data = [...this.fpi.data];
            //   })
            //   .catch(err => {
            //     console.log(err);
            //   });
          });
        });
      },
      { noload: true }
    );
  },
  methods: {
    getData(callBack) {
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:contractCode|string#or': this.searchValue,
        'ne:state|integer#and': '-1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      $that.getParams(this.params);
      this.osg.setFpi(this.params);
      this.osg.ajax('basic/paymentItem/query.do', this.params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        //收集客户id和工单id一起获取，用于后面反显和动态给表格插列
        // let contactIds = res.data.map(item => item.userId);
        // let SAids = res.data.map(item => item.serviceAppointmentId);
        // if (callBack) callBack({ contactIds, SAids });
        if (callBack) callBack({});
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        console.log(this.formData);
        this.osg.ajax('i/pay/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    getContacts(contactIds) {
      return new Promise((resolve, reject) => {
        if (!contactIds.length) {
          reject('没有订单ids');
          return;
        }
        this.params = {
          _all: '1',
          'in:_id|Array#and': contactIds.join()
        };
        this.osg.ajax('basic/contacts/query.do', this.params, res => {
          if (res && res.data && contactIds) {
            this.contactList = res.data;
            resolve();
          }
        });
      });
    },
    getSA(SAids) {
      return new Promise((resolve, reject) => {
        if (!SAids.length) {
          reject('没有工单ids');
          return;
        }
        this.params = {
          _all: '1',
          'in:_id|Array#and': SAids.join()
        };
        this.osg.ajax('basic/serviceAppointment/query.do', this.params, res => {
          if (res && res.data && SAids) {
            this.SAlist = res.data;
            resolve();
          }
        });
      });
    },
    //被选中的支付记录
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //支付标记
    handleMarkTag(command) {
      let tagTimeList = []; //标记时间
      this.selectedList.forEach(item =>
        tagTimeList.push({
          id: item._id,
          name: 'payTagTime',
          value: command === '' ? '' : this.$util.readableTime()
        })
      );
      //标记标签
      let tagList = this.selectedList.map(item => {
        return {
          id: item._id,
          name: 'payTag',
          value: command
        };
      });
      tagList = tagList.concat(tagTimeList);
      if (tagList && tagList.length) {
        console.log(tagList);
        this.markTagAjax(JSON.stringify(tagList));
      } else {
        this.osg.toast('请至少选择一个！', 'warning');
      }
    },
    //调用标记接口
    markTagAjax(data) {
      this.osg.confirm('确定标记这些吗？', () => {
        this.osg.ajax('basic/paymentItem/markEmbodiment.do', { data }, res => {
          this.selectedList = [];
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    //输入支付金额改变
    paymentItemsChange(value, row) {
      // debugger;
      if (!this.formData.paymentItems) this.formData.paymentItems = {};
      this.formData.paymentItems[row._id] = value;
    },
    formatterCodelabel(cellValue, valueOption) {
      if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    //反显委托人
    formatUserId(row, column, cellValue) {
      for (let item of this.contactList) {
        if (item._id == cellValue) return item.name;
      }
    },
    //计算差额
    formatDifference(row) {
      let difference = this.amountToFixed(
        this.amountToFixed(row.totalAmount) - this.amountToFixed(row.paidAmount)
      );
      return Math.abs(difference) || 0;
    },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    formatterAuditstate(row, column, cellValue) {
      return this.osg.codelabel('auditstate', cellValue);
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    formatterPayType(row, column, cellValue) {
      return this.osg.codelabel('payType', cellValue);
    },
    formatterPayState(row, column, cellValue) {
      // return this.osg.codelabel('payState', cellValue);
      return '已收款';
    },
    //标签
    formatterPayTag(row, column, cellValue) {
      if (cellValue === '') return '';
      return this.osg.codelabel('payTag', cellValue);
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderPayType', cellValue);
    },
    formatterTradeIn(row, column, cellValue) {
      return this.osg.codelabel('tradeIn', cellValue);
    },
    formatterMchPayType(row, column, cellValue) {
      return this.osg.codelabel('mchPayType', cellValue);
    },
    //查询分账记录接口
    getLog(payId) {
      this.osg.ajax(
        '/biz/pps/findByPayId.do',
        {
          payId
        },
        ({ data }) => {
          this.billingRecordShow = true;
          console.log(111111, data);

          // 处理后的数据数组
          let processedData = data.map(item => {
            let resultReceivers;
            switch (item.payType) {
              case 10:
              case 1:
                resultReceivers = item.resultReceivers;
                break;
              case 2:
                resultReceivers = item.receivers;
                break;
              default:
                resultReceivers = []; // 或者其他默认值
            }

            return {
              payType: item.payType,
              id: item._id,
              resultReceivers: resultReceivers,
              createTime: item.createTime
            };
          });

          this.billingRecordList = processedData;
          console.log('原数据', data);
          console.log('处理后', this.billingRecordList);
        }
      );
    },
    // 支付记录结算
    settle(id) {
      this.osg.confirm('是否确认手动生成当前支付记录的结算明细？', () => {
        this.osg.ajax('/basic/paymentItem/settle.do', { id }, () => {
          this.osg.toast('调用成功');
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
input.el-input__inner {
  width: 230px;
}
::v-deep .divisionRecord {
  .el-table__body {
    border-left: 1px solid #ebeef5 !important;
    .cell {
      padding: 0px !important;
    }
    .el-table__cell {
      padding: 0 !important;
      border-right: 1px solid #ebeef5 !important;
      .card-table-cell {
        padding: 8px 0px;
      }
    }
  }
}
</style>
